import request from '@/api/http.js'

//获取单位列表
export function getDivs(data) {
    return request({
        url: 'divs',
        method: 'get',
        params: data,
    })
}

//获取单位数据
export function div(data) {
    return request({
        url: 'div',
        method: 'get',
        params: data,
    })
}

//添加单位/科室
export function divAdd(data) {
    return request({
        url: 'div/add',
        method: 'post',
        data,
    })
}

//编辑单位
export function divEdit(data) {
    return request({
        url: 'div/edit',
        method: 'post',
        data,
    })
}

//删除单位
export function divDelete(data) {
    return request({
        url: 'div/delete',
        method: 'post',
        data,
    })
}
//删除单位表格
export function divEmptyTable(data) {
    return request({
        url: 'div/emptyTable',
        method: 'post',
        data,
    })
}
//从老系统读取部门概况
export function previousGaiKuang(data) {
    return request({
        url: 'div/previousGaiKuang',
        method: 'get',
        params: data,
    })
}

//导入绩效文件
export function addAttachment(data) {
    return request({
        url: 'div/addAttachment',
        method: 'post',
        data,
    })
}

//下载绩效文件
export function downloadAttachment(data) {
    return request({
        url: 'div/downloadAttachment',
        method: 'get',
        params: data,
        responseType: 'blob',
    })
}

//删除绩效文件
export function deleteAttachment(data) {
    return request({
        url: 'div/deleteAttachment',
        method: 'post',
        data,
    })
}

//打包下载指定单位的所有绩效文件
export function downloadAttachments(data) {
    return request({
        url: 'div/downloadAttachments',
        method: 'get',
        params: data,
        responseType: 'blob',
    })
}

//个人上传pdf
export function personUpload(data) {
    return request({
        url: 'div/uploadCustomPdf',
        method: 'post',
        data
    })
}

//个人删除pdf
export function perdeletePdf(data) {
    return request({
        url: 'div/deleteCustomPdf',
        method: 'post',
        data
    })
}

//个人下载pdf
export function personDownload(data) {
    return request({
        url: 'div/downloadCustomPdf',
        method: 'get',
        params: data,
        responseType: 'blob',
    })
}

//下载单位
export function downloadDivs(data) {
    return request({
        url: 'divs/downloadDivs',
        method: 'get',
        params: data,
        responseType: 'arraybuffer',
    })
}

export function tuihuiyuanyin(data) {
    return request({
        url: 'divs/tuihuiyuanyin',
        method: 'get',
        params: data,
        responseType: 'arraybuffer',
    })
}
//修改表格数据
export function modifyTable(data) {
    return request({
        url: 'div/table',
        method: 'post',
        data
    })
}

//复制单位数据
export function copyDetail(data) {
    return request({
        url: 'div/copy',
        method: 'post',
        data
    })
}

// 是否可以退回
export function preTuihui(data) {
    return request({
        url: 'div/preTuihui',
        method: 'get',
        params: data,
    })
}